/**
 * Flat list of every enterprise/PCN node that participates in the Network
 * navigation tree — Asset, NetworkSegment, NetworkDevice — with parent ids
 * so {@link NetworkTreeNav} can rebuild the hierarchy client-side (same
 * pattern as `PLANT_DCS_TREE_CYPHER` / `PLANT_ROBOTICS_TREE_CYPHER`).
 *
 * These come from the Experion EMDB ingest (the CANE + Assets projects).
 * Computers/servers are modeled as `Compute` and hang off the Site via
 * HAS_COMPUTE (or off a tree node via CONTAINS); they are not tree rows —
 * they surface as cross-links on each node's detail panel and keep their
 * own Compute tab.
 *
 * Parent edge (all three kinds): the containing Asset / NetworkSegment /
 * NetworkDevice reached by an incoming CONTAINS. A node contained directly
 * by the Site (an Asset root, or a NetworkSegment whose EMDB parent was a
 * skipped organizational node) has no tree-kind parent, so `parentId` is
 * null and it renders at the root.
 */
export const PLANT_NETWORK_TREE_CYPHER = `
            MATCH (n)
              WHERE (n:Asset OR n:NetworkSegment OR n:NetworkDevice)
            WITH n,
                 head([(n)<-[:CONTAINS]-(p)
                        WHERE (p:Asset OR p:NetworkSegment OR p:NetworkDevice) | p]) AS parent,
                 head([(n)-[:BELONGS_TO]->(proj:EmdbProject) | proj]) AS project
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(child)
                WHERE (child:Asset OR child:NetworkSegment OR child:NetworkDevice)
              RETURN count(distinct child) AS childCount
            }
            RETURN n AS node,
                   CASE WHEN parent IS NULL THEN NULL ELSE parent.id END AS parentId,
                   CASE
                     WHEN n:Asset THEN 'Asset'
                     WHEN n:NetworkSegment THEN 'NetworkSegment'
                     WHEN n:NetworkDevice THEN 'NetworkDevice'
                   END AS kind,
                   childCount,
                   CASE WHEN project IS NULL THEN NULL ELSE project.id END AS projectId,
                   CASE WHEN project IS NULL THEN NULL ELSE project.name END AS projectName
            ORDER BY toLower(coalesce(n.name, n.id))
            LIMIT 10000
          `
